<ng-container *ngIf="measureUnitState$ | async as state">
    <div class="measure-unit-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <button mat-mini-fab
                    matTooltip="{{ 'app.page.measure-unit.actions.add.label' | translate }}"
                    color="primary"
                    (click)="onOpenDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.measure-unit.name.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <ng-container matColumnDef="shortName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.measure-unit.shortName.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.shortName != null; else displayPlaceholder">
                            {{element.shortName}}
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="erpMeasureNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.measure-unit.erpMeasureNr.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.erpMeasureNr != null; else displayPlaceholder">
                            {{element.erpMeasureNr}}
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                color="primary"
                                matTooltip="{{ 'app.page.measure-unit.actions.edit.label' | translate }}"
                                (click)="onOpenDialog(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.measure-unit.actions.delete.label' | translate }}"
                                (click)="onDeleteMeasureUnit(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-template #displayPlaceholder>-</ng-template>

                <tr mat-header-row *matHeaderRowDef="state.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.columns;"></tr>

            </table>
        </div>
        <mat-paginator showFirstLastButtons [pageSize]="20" [pageSizeOptions]="[20, 50]"></mat-paginator>
    </div>
</ng-container>
